// Chnages worning modal component
import React from "react";

const ChangesWarningModal = ({ closeChangesWarningModal, message }) => {
  const onClickOk = () => {
    closeChangesWarningModal(false);
  };
  return (
    <>
      <div className="modal-custom">
        <div className="modal-dialog m-0">
          <div className="modal-content">
            <div className="modal-title-custom mb-0">
              <h2 className="text-white mb-0 me-auto modal-title">Discard Changes?</h2>
              <div className="close-icon text-end">
                <button
                  type="button"
                  className="close"
                  aria-label="close modal"
                  data-dismiss="modal"
                  onClick={() => closeChangesWarningModal(true)}
                >
                  <span aria-hidden="true">
                    <i className="fa fa-times text-red" />
                  </span>
                </button>
              </div>
            </div>
            <div className="rotation-option" style={{ marginTop: "30px" }}>
              <div className="form-group">
                <div style={{ color: "white" }}>{message}</div>
              </div>
            </div>
            <div className="d-flex justify-content-center mt-6">
              <button type="submit" className="btn btn-primary" onClick={onClickOk}>
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangesWarningModal;
